module.exports = __webpack_public_path__ + "img/tipperary.f2129497.jpg";